export default Backbone.Model.extend({
  initialize: function (id) {
    this.set("status_date", new Date(this.get("status_date")));
  }
});